<template>
    <section class="compliance-scip-number-section">
        <h5 class="mb-1">{{ translate(titleKey, 'SCIP information') }}</h5>
        <b-form-group
            :label="translate(labelKey, 'SCIP number')"
            label-for="workflow-compliance-scip-number"
            class="mb-0"
        >
            <b-form-input
                id="workflow-compliance-scip-number"
                :value="value"
                :state="inputState"
                @input="$emit('input', $event)"
            />
        </b-form-group>
    </section>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
    name: 'ComplianceScipNumberSection',
    components: { BFormGroup, BFormInput },
    props: {
        value: { type: String, default: '' },
        required: { type: Boolean, default: false },
    },
    data() {
        return {
            titleKey: 'Page(ReceivedRequest):Component(ComplianceInformation):scip-title',
            labelKey: 'Component(Label):scip-number',
        }
    },
    computed: {
        inputState() {
            return this.required ? this.value.trim().length > 0 : null
        },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)
            return translation && translation !== key ? translation : fallback
        },
    },
}
</script>

<style lang="scss" scoped>
.compliance-scip-number-section {
    max-width: 50%;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #ebe9f1;
}

@media (max-width: 767.98px) {
    .compliance-scip-number-section {
        max-width: 100%;
    }
}
</style>
